import { useState, useRef, Dispatch, SetStateAction } from 'react';
import { ImgUploadIcon } from '@/components/SvgIcons/ImgUploadIcon';

type FileUploadProps = {
  setFileUpload: Dispatch<SetStateAction<File | undefined>>;
  imgTextAccepted?: string;
  title?: string;
};

const FileUpload = ({
  setFileUpload,
  imgTextAccepted = 'PNG, JPG, MP4, MOV, ...',
  title = 'Sélectionner un fichier',
}: FileUploadProps) => {
  const [file, setFile] = useState<File>();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleUploaderClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
      setFileUpload(event.target.files[0]);
    }
  };

  return (
    <div>
      <div
        className="flex flex-wrap sm:flex-nowrap w-full gap-5 lg:gap-7.5 cursor-pointer justify-center"
        onClick={handleUploaderClick}
      >
        <img
          alt=""
          className="h-[35px] mt-2"
          src="assets/media/brand-logos/hex-lab.svg"
        />
        <div className="flex bg-center max-w-72 lg:w-full p-5 lg:p-7 bg-no-repeat bg-[length:550px] bg-[url('/media/images/2600x1200/bg-5.png')] border border-gray-300 rounded-xl border-dashed">
          <div className="flex flex-col place-items-center place-content-center text-center rounded-xl w-full">
            <div className="flex items-center mb-2.5">
              <div className="relative size-11 shrink-0">
                <ImgUploadIcon className="w-[44px] h-[44px] stroke-brand-clarity fill-light" />
                <div className="absolute leading-none left-2/4 top-2/4 -translate-y-2/4 -translate-x-2/4">
                  <i className="ki-filled ki-picture text-xl ps-px text-brand"></i>
                </div>
              </div>
            </div>
            {file && (
              <p className="text-gray-800 text-[0.75rem] font-semibold mb-px">
                {title}
              </p>
            )}
            {!file && (
              <p className="text-gray-800 text-[0.75rem] font-semibold mb-px">
                Sélectionner un fichier
              </p>
            )}
            <span className="text-2xs font-medium text-gray-600 text-nowrap">
              {imgTextAccepted}
            </span>
          </div>
        </div>
      </div>
      <input
        className="file-input hidden"
        multiple
        type="file"
        onChange={handleFileChange}
        ref={inputRef}
      />
    </div>
  );
};

export default FileUpload;
